import { Component, Inject, Input, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ButtonControlService } from '../../../../services/button-control.service';
import { DatosSeccionWizardEventsService } from '../../../../services/datos-seccion-wizard-events.service';
import { WIZARD_DATA } from '../../../../tokens/tokens';
import {PasoWizard} from "../../../../interface/wizard-informacion.types";
import { KeycloakService } from 'keycloak-angular';
import { BiosphereService } from '../../../../services/biosphere.service';
import { MessageCrudService } from '@evomatik/evk-common';
import {EvkSeccionModel} from '../../../../../expediente/models/evk-seccion.model';

@Component({
  selector: 'lib-biometricos-biosphere',
  templateUrl: './biometricos-biosphere.component.html',
  styleUrls: ['./biometricos-biosphere.component.css']
})
export class BiometricosBiosphereComponent implements OnInit {
  @Input()
  config: PasoWizard;
  @Input()
  biosphereConfig: any;
  validData: boolean = true;
  errorBiometrics: boolean = false;
  userInfo: any = {};
  dataUser: any = {};
  loading: any = false;

  constructor(
    private fb: FormBuilder,
    private buttonControlService: ButtonControlService,
    @Inject(WIZARD_DATA) public data: any,
    public datosSeccionWizard: DatosSeccionWizardEventsService,
    private keycloakService: KeycloakService,
    private biosphereService: BiosphereService,
    public messageCrudService: MessageCrudService,
  ) {
  }

  ngOnInit() {
    this.buttonControlService.cambiarBotonSiguiente(false);
    console.debug("lib-biometricos-biosphere");
    console.debug(this.biosphereConfig)
    const value = this.data?.paso?.inData?.expediente?.secciones?.filter((sec: any) => sec.origen === "datosNombre");
    const valueIne = this.data?.paso?.inData?.expediente?.secciones?.filter((sec: any) => sec.origen === "datosIdentificacion");
    this.keycloakService.getToken().then((data) => {
      this.dataUser = this.parseJwt(data);
    })
    if(value.length > 0 && valueIne.length > 0){
      if(value[0].propiedades?.a2DatosGenerales?.a2DatosCurpRfc?.curp
        && value[0].propiedades?.a2DatosGenerales?.a2DatosGenerales?.nombre
        && value[0].propiedades?.a2DatosGenerales?.a2DatosGenerales?.primerApellido
        && (valueIne[0].propiedades?.a2FolioCurpRfc?.a2FolioCurpRfc?.folioIne || valueIne[0].propiedades?.a2FolioCurpRfc?.a2FolioCurpRfc?.numeroPasaporte)
        && this.biosphereConfig && this.biosphereConfig?.clientSecret && this.biosphereConfig?.clientId
          && this.biosphereConfig?.operacion){
        this.userInfo = {
          "timestamp": (new Date()).toISOString(),
          "trabajador":{
              "curp": this.toUpperCase(value[0].propiedades?.a2DatosGenerales?.a2DatosCurpRfc?.curp),
              "nombre": this.toUpperCase(value[0].propiedades?.a2DatosGenerales?.a2DatosGenerales?.nombre),
              "apellidoPaterno": this.toUpperCase(value[0].propiedades?.a2DatosGenerales?.a2DatosGenerales?.primerApellido),
              "apellidoMaterno": this.toUpperCase(value[0].propiedades?.a2DatosGenerales?.a2DatosGenerales?.segundoApellido? value[0].propiedades?.a2DatosGenerales?.a2DatosGenerales?.segundoApellido : ""),
              "tipoDocumentoId": valueIne[0].propiedades?.a2FolioCurpRfc?.a2FolioCurpRfc?.folioIne?
                16 : 1,//16=ine, 1=pasaporte
              "numeroId": this.toUpperCase(valueIne[0].propiedades?.a2FolioCurpRfc?.a2FolioCurpRfc?.folioIne?
                valueIne[0].propiedades?.a2FolioCurpRfc?.a2FolioCurpRfc?.folioIne : valueIne[0].propiedades?.a2FolioCurpRfc?.a2FolioCurpRfc?.numeroPasaporte),
              // "numeroId2": value[0].propiedades?.expediente?.id,
              // "numeroId3": value[0].propiedades?.expediente?.folioProvisional,
          },
          "operacion":
            this.biosphereConfig?.operacion?
            {
              ...this.biosphereConfig?.operacion,
              "clave": this.toUpperCase(value[0].propiedades?.expediente?.folioProvisional),
            }
            :
            {
              "flujoLocal": "sequence9 Simulador",
              "clave": this.toUpperCase(value[0].propiedades?.expediente?.folioProvisional),
              "otp": 0,
              "numeroDelegacion": null,
              "nombreDelegacion": null,
              "numeroCESI": null,
              "nombreCESI": null,
              "enrolamientoCertificado": false
            }
        }
      } else {
        this.validData = false;
      }
    } else {
      this.validData = false;
    }
  }

  toUpperCase(value){
    if(value){
      return (new String(value)).toLocaleUpperCase();
    } else {
      return value;
    }
  }

  parseJwt(token) {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }

  startBiometrics(){
    this.userInfo.funcionario = {
      "curp": this.dataUser.curp,
    };
    this.biosphereService.calculateSignature(this.biosphereConfig?.clientSecret, JSON.stringify(this.userInfo)).subscribe((hashHex)=> {
      const request = {
        clientId: this.biosphereConfig?.clientId,
        payload: JSON.stringify(this.userInfo),
        signature: hashHex
      };
      this.loading = true;
      this.setError(true);
      this.biosphereService.invokeBioSphere(JSON.stringify(request), this.biosphereConfig).subscribe((result) => {
        console.debug('Resultado BioSphere: ' + result.resultado + '; Mensaje BioSphere: ' + result.mensaje, false);
        console.debug(JSON.stringify(result));
        this.loading = false;
        if(1 === result.resultado){
          this.setChanges(result);
        } else {
          this.setError(false);
        }
      },
      (error) => {
        console.log("error");
        this.loading = false;
        this.setError(false);
      })
    },
    (error) => {
      this.loading = false;
      this.setError(false);
    })
  }

  setChanges(values) {
    this.buttonControlService.cambiarBotonSiguiente(true);
    const response: EvkSeccionModel = {
        origen: this.config.nombre,
        propiedades: values,
    };
    this.datosSeccionWizard.doneSave(response);
  }

  setError(clean: boolean){
    this.errorBiometrics = clean? false : true;
    if(!clean){
      this.messageCrudService.snackbarMessage('Ocurrió un error durante la lectura de los biométricos');
    }
  }

}
